import React from 'react';
import { FileText, Timer } from 'phosphor-react';
import { StepLog } from '../../types/entities';
import { formatDuration } from '../../use/useRoutineProgress';
import ReactionBadge from '../progress/ReactionBadge';

interface RoutineLogModalBodyProps {
  completedSteps: StepLog[];
  notes?: string;
  onClose: () => void;
}

export default function RoutineLogModalBody({ completedSteps, notes, onClose }: RoutineLogModalBodyProps) {
  return (
    <div className="px-5 py-4 flex flex-col gap-3 overflow-y-auto flex-1">
      {completedSteps.length > 0 ? (
        <div className="flex flex-col gap-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-nude-500 dark:text-gray-400">
            Etapas realizadas
          </p>
          <div className="stagger flex flex-col gap-1.5">
            {completedSteps.map((sl, i) => {
              const stepDur = formatDuration(sl.durationSeconds);
              return (
                <div key={sl.id ?? i} className="bg-nude-50 dark:bg-gray-700 rounded-xl px-3 py-2.5 flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-blush-100 dark:bg-blush-900/30 text-blush-600 dark:text-blush-400 text-[10px] font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                    {i + 1}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-semibold text-gray-700 dark:text-gray-200 truncate">{sl.stepName}</p>
                    <div className="flex items-center gap-2 mt-1 flex-wrap">
                      <ReactionBadge reaction={sl.reaction} />
                      {stepDur && (
                        <span className="flex items-center gap-1 text-[11px] text-lavender-500">
                          <Timer className="w-3 h-3" /> {stepDur}
                        </span>
                      )}
                    </div>
                    {sl.notes && (
                      <p className="text-[11px] text-nude-400 dark:text-gray-500 mt-1 italic">{sl.notes}</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <p className="text-xs text-nude-300 dark:text-gray-500 italic text-center py-4">
          Nenhuma etapa registrada nesta sessão.
        </p>
      )}

      {notes && (
        <div className="flex items-start gap-2 bg-nude-50 dark:bg-gray-700 rounded-xl px-3 py-2.5">
          <FileText className="w-3.5 h-3.5 text-nude-400 dark:text-gray-500 mt-0.5 flex-shrink-0" />
          <p className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed">{notes}</p>
        </div>
      )}

      <button
        onClick={onClose}
        className="mt-1 w-full py-3 bg-nude-100 dark:bg-gray-700 hover:bg-nude-200 dark:hover:bg-gray-600 text-nude-600 dark:text-gray-300 font-semibold text-sm rounded-xl transition-colors active:scale-[0.97]"
      >
        Fechar
      </button>
    </div>
  );
}
